export default "__VITE_ASSET__B8T_SRSN__"